<template>

  <ob-dialog :heading="$t('map.controls.filters')" @ok="ok()" @cancel="close()">
    <asset-types-tree v-model="values.assetTypes"></asset-types-tree>
  </ob-dialog>

</template>

<script>

import AssetTypeAutocomplete from '../../asset-types/asset-type-autocomplete'
import AssetTypesTree from '../../asset-types/asset-types-tree'
import ObDialog from "../../shared/components/dialog";

export default {
  name: 'filter-dialog',

  props: [ 'filter' ],

  data () {
    return {
      values: {
        assetTypes: []
      }
    }
  },

  computed: {

  },

  methods: {
    ok () {
      if (!this.values.assetTypes.length)
        delete this.values.assetTypes

      this.$emit('submit', this.values)
    },

    close () {
      this.$emit('submit', false)
    },
  },

  mounted () {
    Object.assign(this.values, this.filter)
  },

  components: {
    ObDialog,
    AssetTypeAutocomplete,
    AssetTypesTree
  }
}

</script>

<style lang="scss" scoped>

.v-card__actions {
  justify-content: flex-end;
}

</style>
